<template>
  <div class="w-full rounded-[32px] bg-white px-8 py-14 shadow-widget">
    <div
      class="mx-auto grid max-w-[360px] justify-items-center gap-5 text-center"
    >
      <div class="relative h-16 w-16">
        <span class="absolute inset-0 rounded-full border-4 border-brand/15" />
        <span
          class="absolute inset-0 animate-spin rounded-full border-4 border-transparent border-t-brand"
        />
      </div>
      <div>
        <p class="text-lg font-semibold">Загружаем виджет</p>
      </div>
    </div>
  </div>
</template>
